/**
 * InviteParentModal
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import useLocaleContext from 'containers/LanguageProvider/useLocaleContext.js';
import { Button, ButtonGroup, Modal } from 'react-bootstrap';
import { intlTags } from 'utils/intlFunctions.jsx';
import messages from '../messages.js';
import InviteFrame from '../InviteUsers/InviteFrame.jsx';
import EmailInvite from '../InviteUsers/EmailInvite/index.jsx';
import SelectLanguage from '../../../interaction/SelectLanguage/index.jsx';

function InviteParentModal(props) {
  const { user, onHide } = props;
  const { loading, id, connectionCodeParent } = user || {};
  const { locale } = useLocaleContext();
  const [language, setLanguage] = useState(locale);
  const codeValues = {
    code: connectionCodeParent,
    ...intlTags(['samp']),
  };
  const printLink = `#print-${language}/parent/student/${id}`;
  return (
    <Modal show={Boolean(user)} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage {...messages.inviteParents} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={connectionCodeParent ? '' : 'invisible'}>
        <p className="form-text"><FormattedMessage {...messages.inviteParentIntro} values={user} /></p>
        <p className="form-text"><FormattedMessage {...messages.connectionCodeForThis} values={codeValues} /></p>
        {!loading && (
          <InviteFrame>
            <InviteFrame.Print>
              <p className="form-text"><FormattedMessage {...messages.invitePrintHelp} values={{ roleName: 'student' }} /></p>
              <ButtonGroup className="my-5">
                <Button variant="primary" href={printLink}><FormattedMessage {...messages.invitePrintButton} /></Button>
                <SelectLanguage value={language} onChange={setLanguage} />
              </ButtonGroup>
          </InviteFrame.Print>
            <InviteFrame.Email>
              <EmailInvite roleName="student" userId={id} onClose={onHide} />
            </InviteFrame.Email>
          </InviteFrame>
        )}
      </Modal.Body>
    </Modal>
  );
}

InviteParentModal.propTypes = {
  user: PropTypes.object,
  onHide: PropTypes.func,
};

export default InviteParentModal;
